import { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiError } from "../../lib/api";
import { AdminShell } from "../../components/AdminShell";

const INPUT_CLASS =
  "w-full border border-white/10 bg-[#0d0d0d] px-4 py-3 text-sm font-light text-[#F5F5F5] placeholder:text-[#5a5a5a] transition-colors duration-300 focus:border-gold focus:outline-none rounded-none";

const FIELDS = [
  ["judul_atas", "Nama Organisasi (atas)"],
  ["judul", "Judul Pengumuman"],
  ["label_jadwal", "Label Jadwal"],
  ["jadwal", "Isi Jadwal"],
  ["sekretariat", "Alamat Sekretariat"],
  ["kontak", "Kontak Konfirmasi"],
  ["email", "Email"],
  ["website", "Website"],
];

export default function AdminPengumuman() {
  const [form, setForm] = useState(null);
  const [saving, setSaving] = useState(false);
  const navigate = useNavigate();

  const load = useCallback(() => {
    api.get("/pengumuman").then((r) => setForm(r.data)).catch(() => toast.error("Gagal memuat pengumuman."));
  }, []);

  useEffect(() => { load(); }, [load]);

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      const { id, ...payload } = form;
      await api.put("/pengumuman", payload);
      toast.success("Pengumuman disimpan dan langsung tayang di Beranda.");
    } catch (err) {
      if (err.response?.status === 401) {
        localStorage.removeItem("ylbh_admin_token");
        navigate("/admin/login");
      } else {
        toast.error(formatApiError(err.response?.data?.detail) || "Gagal menyimpan pengumuman.");
      }
    } finally {
      setSaving(false);
    }
  };

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  return (
    <AdminShell title="Pengumuman Beranda">
      <h1 className="font-serif text-4xl text-[#F5F5F5]">Pop-up Pengumuman</h1>
      <p className="mt-3 max-w-2xl text-sm font-light text-[#A3A3A3]">
        Pengumuman ini muncul otomatis di Beranda setiap halaman selesai dimuat.
        Ubah isinya di bawah ini, atau matikan sementara tanpa menghapus isinya.
      </p>

      {form === null ? (
        <p className="py-16 text-center font-serif text-xl italic text-[#737373]">Memuat…</p>
      ) : (
        <form
          data-testid="pengumuman-form"
          onSubmit={submit}
          className="mt-8 space-y-5 border border-gold/30 bg-[#0A0A0A] p-6 lg:p-8"
        >
          <label className="flex cursor-pointer items-center gap-3 border border-white/10 bg-[#0d0d0d] px-4 py-3.5">
            <input
              type="checkbox"
              checked={form.aktif}
              onChange={(e) => setForm((f) => ({ ...f, aktif: e.target.checked }))}
              data-testid="pengumuman-aktif-toggle"
              className="h-4 w-4 accent-[#C5A059]"
            />
            <span className="text-sm font-medium text-[#F5F5F5]">
              Tampilkan pop-up pengumuman di Beranda
            </span>
          </label>

          <div className="grid gap-5 sm:grid-cols-2">
            {FIELDS.map(([field, label]) => (
              <div key={field} className={field === "judul" ? "sm:col-span-2" : ""}>
                <label className="mb-2 block text-[11px] font-medium uppercase tracking-[0.3em] text-[#A3A3A3]">
                  {label} *
                </label>
                <input
                  data-testid={`pengumuman-${field.replace(/_/g, "-")}-input`}
                  required
                  minLength={2}
                  value={form[field]}
                  onChange={set(field)}
                  className={INPUT_CLASS}
                />
              </div>
            ))}
          </div>

          <button
            type="submit"
            data-testid="pengumuman-simpan-button"
            disabled={saving}
            className="bg-gold px-8 py-3.5 text-[12px] font-semibold uppercase tracking-[0.2em] text-ink transition-all hover:bg-gold-light disabled:opacity-60"
          >
            {saving ? "Menyimpan…" : "Simpan Pengumuman"}
          </button>
        </form>
      )}
    </AdminShell>
  );
}
